import HelpTooltip from '@/app/common/components/HelpTooltip';
import { guideTooltipHtml } from './CoverageHelpTip';

const STATS_CARD_GUIDES = {
  request: {
    matchKey: 'stats-card-request',
    title: 'درخواست',
    paragraphs: [
      'تعداد ارسال‌ها در بازهٔ زمانی انتخاب‌شده بالای صفحه.',
      'هر بار ارسال دستی یا هر اجرای زمان‌بندی یک درخواست است؛ تعداد آدرس داخل آن ارسال اینجا شمرده نمی‌شود.',
      'مثال: ۶ زمان‌بندی روزانه = ۶ درخواست، حتی اگر هر کدام بیش از ۱۰۰ آدرس داشته باشد.',
    ],
  },
  requestSuccess: {
    matchKey: 'stats-card-request-success',
    title: 'درخواست موفق',
    paragraphs: [
      'تعداد ارسال‌هایی که در همان بازه کامل تمام شده‌اند.',
      'موفق بودن درخواست یعنی خودِ ارسال تمام شده است؛ با تعداد آدرس موفق یکی نیست.',
    ],
  },
  requestFailed: {
    matchKey: 'stats-card-request-failed',
    title: 'درخواست ناموفق',
    paragraphs: [
      'تعداد ارسال‌هایی که در همان بازه ناموفق، ناقص یا متوقف شده‌اند.',
      'اگر ارسال کامل تمام شود و فقط چند آدرس خطا بدهند، آن درخواست اینجا نمی‌آید؛ همان آدرس‌ها در «آدرس ناموفق» جمع می‌شوند.',
    ],
  },
  urlSuccess: {
    matchKey: 'stats-card-url-success',
    title: 'آدرس موفق',
    paragraphs: [
      'جمع تعداد آدرس‌هایی که در ارسال‌های همین بازه با موفقیت پردازش شده‌اند.',
      'مثال: ۳ درخواست با ۵۰ + ۳۰ + ۲۰ آدرس موفق = ۱۰۰ آدرس؛ کارت «درخواست موفق» همان ۳ می‌ماند.',
    ],
  },
  urlFailed: {
    matchKey: 'stats-card-url-failed',
    title: 'آدرس ناموفق',
    paragraphs: [
      'جمع تعداد آدرس‌هایی که در ارسال‌های همین بازه خطا گرفته‌اند.',
      'یک درخواست می‌تواند موفق باشد و باز چند آدرس ناموفق داشته باشد؛ این کارت همان آدرس‌های خطا را جمع می‌زند.',
    ],
  },
};

export type StatsCardHelpKey = keyof typeof STATS_CARD_GUIDES;

export function StatsCardHelpTip({ card }: { card: StatsCardHelpKey }) {
  return (
    <HelpTooltip
      html={guideTooltipHtml(STATS_CARD_GUIDES[card])}
      placement="top"
      className="ms-1"
    />
  );
}
